module.exports = __webpack_public_path__ + "revicons.17629a5dfe0d3c3946cf.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/assets/js/revolution/fonts/revicons/revicons.ttf?5510888
// module id = ../../../../../src/assets/js/revolution/fonts/revicons/revicons.ttf?5510888
// module chunks = styles